"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    InvalidZipCode: 1,
    AmountNotAvailable: 2,
    ProductOutOfStock: 3
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/exception-types.js
// module id = 569
// module chunks = 0 2